import React from 'react';

export const PresthygCard = ({ className = '', children, ...props }) => (
  <div
    className={`bg-white border border-[var(--ph-slate200)] ${className}`}
    style={{ borderRadius: 'var(--ph-radius-xxl)', boxShadow: 'var(--ph-shadow-soft)' }}
    {...props}
  >
    {children}
  </div>
);

export const PresthygStatCard = ({ label, value, icon: Icon, trend, accentColor = 'var(--ph-teal)', className = '', ...props }) => (
  <PresthygCard className={`p-6 ${className}`} {...props}>
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm font-medium" style={{ color: 'var(--ph-slate500)', fontFamily: 'var(--font-body)' }}>{label}</p>
        <p className="text-3xl font-bold mt-2" style={{ color: 'var(--ph-navy)', fontFamily: 'var(--font-display)' }}>{value}</p>
        {trend && (
          <p className="text-xs mt-2 font-medium" style={{ color: accentColor }}>{trend}</p>
        )}
      </div>
      {Icon && (
        <div className="w-12 h-12 flex items-center justify-center" style={{ borderRadius: 'var(--ph-radius-md)', backgroundColor: `${accentColor}12` }}>
          <Icon size={22} style={{ color: accentColor }} />
        </div>
      )}
    </div>
  </PresthygCard>
);

export const PresthygButton = ({ variant = 'primary', className = '', children, ...props }) => {
  const variants = {
    primary: { backgroundColor: 'var(--ph-navy)', color: '#fff' },
    teal: { backgroundColor: 'var(--ph-teal)', color: '#fff' },
    secondary: { backgroundColor: '#fff', color: 'var(--ph-navy)', border: '1px solid var(--ph-slate200)' },
    ghost: { backgroundColor: 'transparent', color: 'var(--ph-slate700)' },
    terracotta: { backgroundColor: 'var(--ph-terracotta)', color: '#fff' },
  };
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold transition-all hover:opacity-90 disabled:opacity-50 ${className}`}
      style={{ borderRadius: 'var(--ph-radius-pill)', ...variants[variant] }}
      {...props}
    >
      {children}
    </button>
  );
};

export const PresthygBadge = ({ status = 'draft', children, className = '' }) => {
  const styles = {
    compliant: { backgroundColor: '#ECFDF5', color: '#047857' },
    draft: { backgroundColor: '#EFF6FF', color: '#1D4ED8' },
    incomplete: { backgroundColor: '#FFFBEB', color: '#B45309' },
    error: { backgroundColor: '#FEF2F2', color: '#B91C1C' },
    validated: { backgroundColor: '#ECFDF5', color: '#047857' },
    neutral: { backgroundColor: 'var(--ph-slate100)', color: 'var(--ph-slate700)' },
  };
  return (
    <span
      className={`inline-flex items-center px-3 py-1 text-xs font-semibold ${className}`}
      style={{ borderRadius: 'var(--ph-radius-pill)', ...(styles[status] || styles.neutral) }}
    >
      {children}
    </span>
  );
};

export const PresthygPageHeader = ({ title, subtitle, actions, className = '' }) => (
  <div className={`flex items-start justify-between mb-8 ${className}`}>
    <div>
      <h1 className="text-2xl font-bold" style={{ color: 'var(--ph-navy)', fontFamily: 'var(--font-display)' }}>
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm" style={{ color: 'var(--ph-slate500)' }}>{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-3">{actions}</div>}
  </div>
);

export const PresthygEmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 px-8 text-center">
    {Icon && (
      <div className="w-16 h-16 flex items-center justify-center mb-5" style={{ borderRadius: 'var(--ph-radius-xl)', backgroundColor: 'var(--ph-slate100)' }}>
        <Icon size={28} style={{ color: 'var(--ph-slate500)' }} />
      </div>
    )}
    <h3 className="text-base font-semibold mb-1" style={{ color: 'var(--ph-navy)' }}>{title}</h3>
    {description && <p className="text-sm mb-5" style={{ color: 'var(--ph-slate500)' }}>{description}</p>}
    {action}
  </div>
);
